import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import ShopByHeaderSection from 'components/consumer/ShopByHeaderSection';
import TogglePillGroup from 'components/consumer/TogglePillGroup';
import TierInfoTooltip from './TierInfoTooltip';
const DesktopTierFilters = t0 => {
  const $ = _c(10);
  const {
    fabricTiers,
    toggleSelectedTier,
    selectedTiers
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <>Tier <TierInfoTooltip /></>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== fabricTiers || $[2] !== selectedTiers || $[3] !== toggleSelectedTier) {
    let t3;
    if ($[5] !== selectedTiers || $[6] !== toggleSelectedTier) {
      t3 = tier => ({
        label: `Tier ${tier}`,
        id: tier.toString(),
        onClick: () => {
          toggleSelectedTier(tier);
        },
        isSelected: selectedTiers.includes(tier)
      });
      $[5] = selectedTiers;
      $[6] = toggleSelectedTier;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    t2 = fabricTiers.map(t3);
    $[1] = fabricTiers;
    $[2] = selectedTiers;
    $[3] = toggleSelectedTier;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[8] !== t2) {
    t3 = <ShopByHeaderSection label={t1} labelClassName="flex items-center"><TogglePillGroup items={t2} variant="ShopByHeaderSection" /></ShopByHeaderSection>;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};
DesktopTierFilters.propTypes = {
  fabricTiers: PropTypes.node,
  toggleSelectedTier: PropTypes.func,
  selectedTiers: PropTypes.node
};
export default DesktopTierFilters;